// ************************************************************************************************************************************************************
//
// CONFIDENTIAL
// Unpublished Work, Copyright 2023, Baxter Healthcare Corporation. All rights reserved.
// For use only by Baxter Healthcare Corporation.
// This document contains proprietary information. It must not be reproduced
// or disclosed to others without prior written approval.
//
// Filename: AppWithRouterAccess.js
// Description: This file is responsible for Route the header page if user is authorized.
//
// ************************************************************************************************************************************************************
import React from "react";
import { Route, Redirect, Switch } from "react-router-dom";
import { useOktaAuth } from "@okta/okta-react";
import { AuthPage } from "./AuthPage";
import { ErrorPage1 } from "../../errors/ErrorPage1";
import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import reducer from "../../redux/reducer";
import Header from "../../header/Header";

 /* The store is recreated each time AppWithRouterAccess renders for any reason.*/
 /* Create the store outside the component so it's instantiated only once.*/
const store = createStore(reducer, applyMiddleware(thunk));

const AppWithRouterAccess = () => {

  const { authState } = useOktaAuth();

  return (
    /* provider used to integrates redux store with react application */
    /* redux provides a centralized store to manage the state of application */
    <Provider store={store}>
    <Switch>
      {!authState.isAuthenticated ? (
        /*Render auth page when user at `/auth` and not authorized.*/

        <Route>
          <AuthPage />
        </Route>
      ) : (
        /*Otherwise redirect to root page (`/`)*/
        <Redirect from="/auth" to="/" />
      )}

      <Route path="/error" component={ErrorPage1} />

      {!authState.isAuthenticated ? (
        /*Redirect to `/auth` when user is not authorized*/
        <Redirect to="/auth/login" />
      ) : (
        <>
         
            <Header />
         
        </>
      )}
    </Switch>
    </Provider>
  );
};

export default AppWithRouterAccess;
